import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { clsx as m } from "../../utils/clsx.js";
import '../../assets/InfoPanel.css';const p = "_root_43rns_1", y = "_inline_43rns_37", d = "_icon_43rns_58", f = "_content_43rns_61", n = {
  root: p,
  "type-default": "_type-default_43rns_11",
  "type-error": "_type-error_43rns_15",
  "type-success": "_type-success_43rns_19",
  "type-warning": "_type-warning_43rns_23",
  "size-small": "_size-small_43rns_27",
  "size-normal": "_size-normal_43rns_30",
  "size-large": "_size-large_43rns_33",
  inline: y,
  icon: d,
  content: f
};
function N(o) {
  const {
    type: t = "default",
    size: r = "auto",
    icon: s,
    children: i,
    className: _,
    inline: c = !1
  } = o, l = m(n.root, _, n[`type-${t}`], n[`size-${r}`], {
    [n.inline]: c
  });
  return /* @__PURE__ */ a("div", { className: l, children: [
    !!s && /* @__PURE__ */ e("div", { className: n.icon, children: s }),
    /* @__PURE__ */ e("div", { className: n.content, children: i })
  ] });
}
export {
  N as InfoPanel
};
